<!--
File: top-menu.component.html
Project: catalog-cloud
File Created: Wednesday, 22nd December 2021 12:48:17
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Wednesday, 3rd July 2024 5:55:05 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<div
  class="flex flex-row min-w-full min-h-full h-4rem align-items-center border-0"
>
  <div class="w-1 pl-4">
    <!-- <p-button
      [icon]="'pi pi-ellipsis-v'"
      [text]="true"
      [raised]="false"
      [size]="'small'"
      [rounded]="true"
      (onClick)="toogleSideNav()"
    >
    </p-button> -->
    <button
      #menubutton
      type="button"
      class="topbar-menubutton p-link p-trigger"
      (click)="onMenuButtonClick()"
    >
      <i class="pi pi-bars"></i>
    </button>
  </div>
  <div class="w-6"></div>
  <div class="flex w-5 justify-content-end pr-3 border-0 min-w-max">
    <user-options-side-menu></user-options-side-menu>
  </div>
</div>
